function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { useState } from 'react';
import { createActiveMonth } from '../../utilities';
import { useActiveMonth } from './useActiveMonth';
import { useMonth } from './useMonth';
import { useYears } from './useYears';
export var useCalendar = props => {
  var {
    weeks,
    activeMonth,
    setActiveMonth: _setActiveMonth,
    focusableDate,
    setFocusableDate,
    focusedDate,
    setFocusedDate,
    getClosestDateToFocus
  } = useActiveMonth(props);
  var [showYearSelection, setShowYearSelection] = useState(false);

  var setActiveMonth = date => {
    _setActiveMonth(createActiveMonth(date));
  };

  var {
    hasMonth: hasPreviousMonth,
    monthLabels: previousMonthLabels,
    goToMonth: goToPreviousMonth
  } = useMonth(_objectSpread(_objectSpread({}, props), {}, {
    monthsToAdd: -1,
    activeMonth,
    onSelect: setActiveMonth,
    setFocusableDate
  }));
  var {
    hasMonth: hasNextMonth,
    monthLabels: nextMonthLabels,
    goToMonth: goToNextMonth
  } = useMonth(_objectSpread(_objectSpread({}, props), {}, {
    monthsToAdd: 1,
    activeMonth,
    onSelect: setActiveMonth,
    setFocusableDate
  }));
  var years = useYears(props);
  return {
    years,
    weeks,
    activeMonth,
    goToNextMonth,
    goToPreviousMonth,
    hasPreviousMonth,
    previousMonthLabels,
    hasNextMonth,
    nextMonthLabels,
    showYearSelection,
    setShowYearSelection,
    setSelectedYear: date => {
      setActiveMonth(date); // reset the focusable date, to undefined for getting the default focusable day from useActiveMonth.

      setFocusableDate(undefined);
    },
    focusableDate,
    focusedDate,
    setFocusedDate,
    // get the available date to focus.
    getClosestDateToFocus
  };
};
//# sourceMappingURL=useCalendar.js.map